import React from 'react'
import { ImLinkedin2 } from 'react-icons/im';
import { AiOutlineTwitter } from 'react-icons/ai';
import { FaWhatsapp } from 'react-icons/fa';
import { MdMailOutline } from 'react-icons/md';
import { AiOutlinePlus } from 'react-icons/ai';
import useIsInViewport from 'use-is-in-viewport'

import Heading3 from '../../../elements/titles/Heading3'
// import Heading3 from '../../../elements/titles/Heading3'
import Paragraph from '../../../elements/p/Paragraph'
import LoadImage from '../../../elements/images/LoadImage'
import Container from '../../../utils/Container'
import Button from '../../../elements/buttons/Button'
import bgTraductionTypes from '../../../../medias/images/bg-traductionTypes.svg'
import about1 from '../../../../medias/images/about1.png'
import about2 from '../../../../medias/images/Creative writing-rafiki.png'
import about3 from '../../../../medias/images/passionate-animate.png'
import about4 from '../../../../medias/images/Personal finance-pana.png'

const InfoBlock = () => {

	const [isInViewport, targetRef] = useIsInViewport()

	return (
		<section
			ref={targetRef}
			className={`${ isInViewport ? "visibleDiv" : "hiddenDiv"}`} 
		>
			<Container classe="flex flex-col space-y-18 md:space-y-20">
				<div className="flex flex-col-reverse md:flex-row items-center  md:space-x-10 lg:space-x-32 mt-16">
					<LoadImage 
						img={about1} 
						alt="une fille entrain de lire un livre"
						classe="w-52 md:w-80 h-auto mt-10 md:mt-0"
					/>
					<div className="mt-5 md:mt-0">
						<Heading3 classe="text-lg md:text-3xl ">Qui je suis ?</Heading3>
						<Paragraph classe="para-about mt-2">
							Je m'appelle Rita Nsangou, <b>Traductrice, correctrice et relectrice professionelle</b>.
							Je suis titulaire d'un master en traduction. 
							<br />Ma passion pour les langues s'est developpée très tôt à l'age de 8 ans.Je lisais beaucoup dans l'optique d'apprendre des langues étrangères, la traduction à été pour moi une evidence.
							<br />
						</Paragraph>
					</div>
				</div>

				<div 
					className={`${ isInViewport ? "visibleDiv" : "hiddenDiv"} flex flex-col-reverse md:flex-row-reverse items-center md:space-x-10 lg:space-x-32 mt-16`}>
					<LoadImage 
						img={about2} 
						alt="une fille entrain d'écrire"
						classe="w-64 md:w-80 h-auto mt-10 md:mt-0"
					/>
					<div className="mt-5 md:mt-0">
						<Heading3 className="font-secondary text-primary text-lg md:text-3xl font-extrabold font-bold leading-snug opacity-90">À propos de mon travail</Heading3>
						<Paragraph classe="para-about mt-2 lg:mr-32">
							Je prends mon travail très au serieux et me force à traduire les documents de mes clients selon le contexte pour une communication parfaite.
							La plupart de mes anciens clients apprecient mon mindset.
						</Paragraph>
					</div>
				</div>

				<div 
					className={`${ isInViewport ? "visibleDiv" : "hiddenDiv"} flex flex-col-reverse md:flex-row items-center md:space-x-10 lg:space-x-32  mt-16`}>
					<LoadImage 
						img={about3} 
						alt="une fille entrain de lire un livre"
						classe="para-about w-52 md:w-80 h-auto mt-10 md:mt-0"
					/>
					<div className="mt-5 md:mt-0">
						<Heading3 className="font-secondary text-primary text-lg md:text-3xl font-extrabold font-bold leading-snug opacity-90">Ce qui me tient à coeur</Heading3>
						<Paragraph classe="para-about mt-2">
						J'aime voir mes clients être satisfait de mon travail c'est pour cette raison que
							ma principale mission est de combler leurs attentes avec une traduction de qualité tout en respectant les delais de livraison.
						</Paragraph>
					</div>
				</div>

				<div className={`${ isInViewport ? "visibleDiv" : "hiddenDiv"} flex flex-col-reverse md:flex-row-reverse items-center md:space-x-10  lg:space-x-32 mt-16`}>
					<LoadImage 
						img={about4} 
						alt="une fille entrain d'écrire"
						classe="w-64 md:w-80 h-auto mt-10 md:mt-0"
					/>
					<div className="mt-5 md:mt-0">
						<Heading3 className="font-secondary text-primary text-lg md:text-3xl font-extrabold font-bold leading-snug opacity-90">Autres</Heading3>
						<Paragraph classe="para-about mt-2 lg:mr-32">
							Je traduis régulièrement des documents pour des associations à but non lucratif, ce qui me permet de venir en aide aux autres et de continuer à me perfectionner dans le métier.
							N'hésitez pas à me contacter pour votre projet de traduction.
						</Paragraph>
					</div>
				</div>

				<div className="flex justify-center mt-20 lg:mt-10">
					<Button
						link="/contact"
						
					>
						Traduire un projet
					</Button>
				</div>
			</Container>
		</section>
	)
}

export default InfoBlock